import { flexRender, Table } from "@tanstack/react-table"

interface BodyProps<T extends object> {
    table: Table<T>
    onRowClick?: (rowData: T) => void
}

/**
 * El body de la taula, on es mostren les dades
 */
function Body<T extends object>({ table, onRowClick }: BodyProps<T>) {
    return (
        <tbody>
            {table.getRowModel().rows.map((row) => (
                <tr key={row.id} onClick={() => {
                    onRowClick?.(row.original)
                }} className={onRowClick ? "clickable" : ""}>
                    {row.getVisibleCells().map((cell) => (
                        <td key={cell.id} className="align-middle">{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                    ))}
                </tr>
            ))}
        </tbody>
    )
}

export default Body
